import { useDateFormatter } from "./useDateFormatter";
import { useDeviceCountersFormatter } from "./useDeviceCountersFormatter";
import { useMeetingsFormatter } from "./useMeetingsFormatter";
import { useTicketsFormatter } from "./useTicketsFormatter";
import { useAlarmsFormatter } from "./useAlarmsFormatter";

export const useDataFormatter = () => {
  const { getRealtimeTickets } = useTicketsFormatter();
  const { getRealtimeDeviceCounters } = useDeviceCountersFormatter();
  const { getRealtimeDate } = useDateFormatter();
  const { getRealtimeMeeting } = useMeetingsFormatter();
  const { getRealtimeAlarms } = useAlarmsFormatter();

  return {
    ticket: getRealtimeTickets,
    device: getRealtimeDeviceCounters,
    date: getRealtimeDate,
    meeting: getRealtimeMeeting,
    alarm: getRealtimeAlarms,
  };
};
